"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _PropTypes = require("./PropTypes.js");

var _reactNumericInput = _interopRequireDefault(require("react-numeric-input"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var settingsFor = function settingsFor(cutoffName) {
  return Object.assign({
    min: 0
  }, cutoffName === "pValue" ? {
    step: 0.01
  } : {
    step: 1.0
  }, cutoffName === "pValue" ? {
    precision: 2
  } : {
    precision: 1
  }, cutoffName === "pValue" ? {
    max: 1
  } : {});
};

var keyValuePair = function keyValuePair(key, value) {
  var result = {};
  result[key] = value;
  return result;
};

var cutoffDisplayName = function cutoffDisplayName(cutoffName) {
  switch (cutoffName) {
    case "value":
      return "Expression value";

    case "pValue":
      return "Adjusted p-value";

    case "foldChange":
      return /*#__PURE__*/_react["default"].createElement("span", null, "Log", /*#__PURE__*/_react["default"].createElement("sub", null, "2"), "-fold change");

    default:
      return cutoffName;
  }
};

var Cutoff = function Cutoff(_ref) {
  var cutoff = _ref.cutoff,
      onChangeCutoff = _ref.onChangeCutoff;
  return /*#__PURE__*/_react["default"].createElement("div", null, Object.keys(cutoff).map(function (cutoffName) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: cutoffName
    }, /*#__PURE__*/_react["default"].createElement("div", null, cutoffDisplayName(cutoffName)), /*#__PURE__*/_react["default"].createElement(_reactNumericInput["default"], _extends({
      className: "form-control",
      value: cutoff[cutoffName]
    }, settingsFor(cutoffName), {
      onChange: function onChange(valueAsNumber) {
        return valueAsNumber !== null && onChangeCutoff(Object.assign({}, cutoff, keyValuePair(cutoffName, valueAsNumber)));
      }
    })));
  }));
};

Cutoff.propTypes = {
  cutoff: _PropTypes.CutoffType.isRequired,
  onChangeCutoff: _propTypes["default"].func.isRequired
};
var _default = Cutoff;
exports["default"] = _default;